import React from 'react';
import { connect } from 'react-redux';
import PaceProgress from './PaceProgress';

const PaceProgressComponent = connect(
    function mapStateToProps(state) {
        return {
            active: state.paceProgress.active,
            total: state.paceProgress.total,
            uploaded: state.paceProgress.uploaded
        };
    },
    function mapDispatchToProps(dispatch) {
        return {};
    }
)(PaceProgress);

export default PaceProgressComponent;
